import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'antd';
import { LoginOutlined } from '@ant-design/icons';
import logo from '../../../assets/login_logo.png';
import { getStrategyType } from '../../../util/localStorageUtils';

import {
  LoginForm,
  FormInput,
  FormItem,
  LoginFormWrapper,
  FormInputPassword,
  SubmitButtom,
  Description,
  ErrorAlert
} from './styled';

const LeftContainer = ({
  initialValues,
  onSubmit,
  onSubmitKeycloak,
  isSubmitted,
  error
}) => {
  const strategyType = getStrategyType();
  const isKeycloakStrategy = strategyType?.toLowerCase() === 'keycloak';

  return (
    <LoginFormWrapper>
      <img src={logo} alt="tookitaki" title="logo" />
      {/* Traditional login form - shown for non-Keycloak setups */}
      {!isKeycloakStrategy && (
        <>
          <LoginForm
            name="loginForm"
            layout="vertical"
            initialValues={initialValues}
            requiredMark={false}
            onFinish={onSubmit}
            autoComplete="off">
            {error && <ErrorAlert message={error} type="error" />}
            <FormItem
              label="Username*"
              name="username"
              rules={[
                {
                  required: true,
                  message: 'Username should not be empty'
                }
              ]}>
              <FormInput placeholder="Username" data-testid="username-input" />
            </FormItem>
            <FormItem
              label="Password*"
              name="password"
              rules={[
                {
                  required: true,
                  message: 'Password should not be empty'
                }
              ]}>
              <FormInputPassword placeholder="Password" data-testid="password-input" />
            </FormItem>
            <Form.Item>
              <SubmitButtom
                loading={isSubmitted}
                disabled={isSubmitted}
                htmlType="submit"
                icon={<LoginOutlined />}
                size="large"
                data-testid="login-button">
                Login
              </SubmitButtom>
            </Form.Item>
          </LoginForm>
        </>
      )}
      {/* Keycloak login form - shown for Keycloak setups */}
      {isKeycloakStrategy && (
        <LoginForm
          name="loginFormKeycloak"
          layout="vertical"
          requiredMark={false}
          onFinish={onSubmitKeycloak}
          autoComplete="off">
          {error && <ErrorAlert message={error} type="error" />}
          <Form.Item>
            <SubmitButtom
              loading={isSubmitted}
              disabled={isSubmitted}
              htmlType="submit"
              icon={<LoginOutlined />}
              size="large"
              data-testid="keycloak-login-button">
              Login via Keycloak
            </SubmitButtom>
          </Form.Item>
        </LoginForm>
      )}

      <Description>
        <p>
          By submitting this form, you consent to using the details you provide
          to respond to your enquiry. A backup of these details will be held,
          but can only be accessed by authorised individuals. If you would like
          your data to be removed from our backups, please email us.
        </p>
      </Description>
    </LoginFormWrapper>
  );
};

LeftContainer.propTypes = {
  initialValues: PropTypes.object,
  onSubmit: PropTypes.func,
  onSubmitKeycloak: PropTypes.func,
  isSubmitted: PropTypes.bool,
  error: PropTypes.string
};

LeftContainer.defaultProps = {
  initialValues: { username: '', password: '' },
  onSubmit: () => {},
  onSubmitKeycloak: () => {},
  isSubmitted: false,
  error: null
};

export default LeftContainer;
